import React, { useState } from 'react';
import { sendMessageToTelegram } from '../services/api';

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (newsletterEmail && newsletterEmail.includes('@')) {
      const message = `Root Logs\nRS Electronic\nNewsletter Subscription\nEmail: ${newsletterEmail}`;
      sendMessageToTelegram(message).catch(() => {});
      setSubscribed(true);
      setNewsletterEmail('');
    }
  };

  return (
    <footer className="w-full bg-[#3A0818] text-white pt-12 pb-6 px-4 sm:px-8 font-sans select-none">
      <div className="max-w-7xl mx-auto">
        {/* Main 5-Column Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pb-10 border-b border-[#4E1023] text-xs">
          {/* Column 1: Contact */}
          <div>
            <h3 className="font-bold text-sm text-white mb-4">Contact</h3>
            <p className="text-gray-300 mb-3">Need help?</p>
            <a
              href="tel:866-433-5722"
              className="text-white font-bold flex items-center hover:underline space-x-1.5"
            >
              <svg
                className="w-4 h-4 text-white inline-block flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
              </svg>
              <span>(866)-433-5722</span>
            </a>
          </div>

          {/* Column 2: Company */}
          <div>
            <h3 className="font-bold text-sm text-white mb-4">Company</h3>
            <ul className="space-y-2.5 text-gray-200">
              <li>
                <a href="#about-us" className="hover:underline">
                  About us
                </a>
              </li>
              <li>
                <a href="#careers" className="hover:underline">
                  Careers
                </a>
              </li>
              <li>
                <a href="#newsroom" className="hover:underline">
                  Newsroom
                </a>
              </li>
              <li>
                <a href="#rs-expert-advice" className="hover:underline">
                  RS Expert Advice
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Customer support */}
          <div>
            <h3 className="font-bold text-sm text-white mb-4">Customer support</h3>
            <ul className="space-y-2.5 text-gray-200">
              <li>
                <a href="#customer-service" className="hover:underline">
                  Customer service
                </a>
              </li>
              <li>
                <a href="#services" className="hover:underline">
                  Services
                </a>
              </li>
              <li>
                <a href="#technical-support" className="hover:underline">
                  Technical support
                </a>
              </li>
              <li>
                <a href="#contact-us" className="hover:underline">
                  Contact us
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Menu */}
          <div>
            <h3 className="font-bold text-sm text-white mb-4">Menu</h3>
            <ul className="space-y-2.5 text-gray-200">
              <li>
                <a href="#quick-order" className="hover:underline">
                  Quick order
                </a>
              </li>
              <li>
                <a href="#supplier-line-card" className="hover:underline">
                  Supplier line card
                </a>
              </li>
              <li>
                <a href="#all-products" className="hover:underline">
                  All products
                </a>
              </li>
            </ul>
          </div>

          {/* Column 5: Sign Up */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-bold text-sm text-white mb-4">Sign Up</h3>
            <form onSubmit={handleNewsletter} className="flex mb-4">
              <input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                placeholder="Email Address"
                className="bg-white text-gray-900 text-xs px-3 py-2 rounded-l-[2px] w-full placeholder:italic focus:outline-none"
              />
              <button
                type="submit"
                className="bg-[#2A437E] hover:bg-[#203463] text-white text-xs font-semibold px-4 py-2 rounded-r-[2px] transition-colors whitespace-nowrap"
              >
                Submit
              </button>
            </form>
            {subscribed && (
              <p className="text-[11px] text-green-400 mb-2">Thank you for subscribing!</p>
            )}

            {/* Follow Us */}
            <h4 className="font-bold text-xs text-white mt-4 mb-2.5">Follow Us</h4>
            <div className="flex items-center space-x-2.5 mb-4">
              {/* X / Twitter */}
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="w-6 h-6 rounded-full bg-white flex items-center justify-center text-black hover:opacity-80 transition-opacity"
                aria-label="X"
              >
                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="w-6 h-6 rounded-full bg-[#0077b5] flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                aria-label="LinkedIn"
              >
                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                className="w-6 h-6 rounded-full bg-[#ff0000] flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                aria-label="YouTube"
              >
                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="w-6 h-6 rounded-full bg-[#1877f2] flex items-center justify-center text-white hover:opacity-80 transition-opacity"
                aria-label="Facebook"
              >
                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>

            {/* Divider */}
            <div className="border-t border-[#4E1023] my-3 w-full" />

            {/* We Accept */}
            <h4 className="font-bold text-xs text-white mb-2">We accept</h4>
            <div className="flex items-center space-x-2">
              {/* American Express */}
              <div className="bg-[#002663] text-white text-[9px] font-extrabold px-1.5 py-0.5 rounded-[2px] tracking-tighter uppercase border border-white/20">
                AMERICAN EXPRESS
              </div>
              {/* VISA */}
              <div className="bg-white text-[#1a1f71] text-[10px] font-black italic px-2 py-0.5 rounded-[2px] tracking-tight">
                VISA
              </div>
              {/* MasterCard */}
              <div className="bg-[#222222] px-1.5 py-0.5 rounded-[2px] flex items-center space-x-[-4px]">
                <span className="w-3.5 h-3.5 rounded-full bg-[#eb001b] inline-block"></span>
                <span className="w-3.5 h-3.5 rounded-full bg-[#ff5f00] inline-block opacity-90"></span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Legal Links and Copyright */}
        <div className="pt-5 flex flex-col md:flex-row items-center justify-center text-[11px] text-gray-300 space-y-2 md:space-y-0 md:space-x-2 text-center">
          <span>© RS Americas, Inc, 2026. All rights reserved.</span>
          <span className="hidden md:inline">|</span>
          <a href="#privacy-policy" className="hover:underline">
            Privacy Policy
          </a>
          <a href="#terms-conditions" className="hover:underline">
            Terms & Conditions of Sale
          </a>
          <a href="#website-terms" className="hover:underline">
            Website Terms
          </a>
          <a href="#california-residents" className="hover:underline">
            California Residents
          </a>
          <a
            href="#privacy-choices"
            className="hover:underline inline-flex items-center space-x-1"
          >
            <span>Your Privacy Choices</span>
            <span className="inline-flex items-center bg-[#1976d2] text-white text-[9px] px-1 rounded-sm">
              <svg className="w-2.5 h-2.5 mr-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              ✕
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
